var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"filter-list"},_vm._l((_vm.filterArray),function(item,index){return _c('li',{key:index},[_c('a',{class:{
                'selected-filter': _vm.filter_value == item.value
            },attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.handleClick(item.value)}}},[_vm._v(" "+_vm._s(item.label)+" ")])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }